<template>
<div id="nav">
    <nav class="navbar navbar-expand-custom">
        <a id="logo" class="navbar-brand" @click.prevent="gohome">
            <!-- <img src="../../assets/Logo.png"/> -->
            <p id="bavbar-brand">Evolve</p>
        </a>
        <button class="back-button" @click="back" v-if="this.$parent.showBackButton">Back to all Members</button>
       
        <div class="welcome-container">
             <p v-if="user" class="welcome">Welcome, {{user.displayName}}</p>
            <button  v-if="user" type="button" @click="togglemenu" class="navbar-toggler">
                <div class="avatar-nav" v-bind:style="{ 'background-image': 'url(' + usericon + ')' }">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <!-- <img :src="usericon" class="usericon rounded-circle"/> -->
            </button>
        </div>
    </nav>
    <div v-if="toggle" id="menu" class="align-content-end"> 
            <ul class="navbar-nav">
                <li v-if="user"><a @click="settings" class="nav-link">Profile Settings</a></li>
                <li v-if="user"><a @click="logout" class="nav-link">Logout</a></li>
            </ul>
        </div>

        
</div>
</template>
<script>
import firebase from '@/firebase/init'
export default {
    name: 'Navbar',
    data(){
        return{
            user: null,
            usericon: null,
            toggle: false,
            user_id: null
        }
    },
    methods:{
        logout(){
            firebase.auth().signOut().then(()=>{
                this.$router.push({name: 'Login'})
            })
        },
        togglemenu(){
            if(this.toggle)
                this.toggle = false
            else
                this.toggle = true
        },
        settings(){
            this.toggle = false
            this.$router.push({name: 'EditProfile'})
        },
        gohome(){
            this.toggle = false
            this.$router.push({name: 'Home'})
        },
        back(){
            this.$router.push({name: 'Home'})
        }
    },
    created(){
        var thisobj = this
        var db = firebase.firestore()
        var storage = firebase.storage()
        var storageRef = storage.ref()
        firebase.auth().onAuthStateChanged((user)=>{
            if(user){
                this.user = user
                let ref = db.collection('users').where('UID', '==', this.user.uid)
                ref.get().then(snapshot=>{
                    snapshot.forEach(doc=>{
                        let userdata = doc.data()
                        this.user_id = doc.id
                        let avatarRef = storageRef.child(userdata.Icon)
                            if(avatarRef.location.path !== ""){
                                avatarRef.getDownloadURL().then(function(url) {
                                    thisobj.usericon = url
                                }).catch(function(error) {user.Icon = ''})
                            }
                    })
                })
            }
            else{
                this.user = null
            }
        })
    }
}
</script>
<style scoped>
#bavbar-brand{
    font-family: GothamRndSSm-Light;
    font-size: 22px;
    color: black;
    margin: 0 0 0 0.5em;
    height: 5%;
    text-align: start;
    bottom: 0;
    text-anchor: end;
    cursor: pointer;
}
#nav{
    margin-bottom: 2em;
}
nav{
    right:0;
     height: 4.7em;
}
.usericon{
    height: 3em;
}
.navbar-toggler{
    border-left: 1px solid #E6E8F1;
}
#menu{
    position: absolute;
    right:0;
    z-index: 2;
    width: 23em;
    background-color: white;
    border: 1px solid #E6E8F1;
    border-top: none;
    font-family: GothamBook;
    font-size: 14px;
    color: #000;
    text-align: left;
    padding: 2em;
    padding-left: 3em;
}
#menu li{
    margin-top: 1em;
    cursor:pointer;
}
.welcome{
    font-size: 18px;
    font-family: GothamBook;
    color: #000;
    text-align: end;
    margin-right: 1em;
    margin-top: 1.5em !important;
    margin-bottom: 0 !important;
    /* border-bottom: 1px solid rgba(151,151,151, 0.25); 
    cursor: auto !important;*/
}
.navbar-toggler:focus,.navbar-toggler:active {
   outline: none !important;
   box-shadow: none;
}
.avatar-nav{
    width: 2.8em;
    height: 2.8em;
    -webkit-border-radius: 60px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 60px;
    -moz-background-clip: padding;
    border-radius: 60px;
    background-clip: padding-box;
    margin: 0 0 0 5px;
    float: left;
    background-size: cover;
    background-position: center center;
}
.back-button{
    font-size: 13px;
    border: 1px solid #a6b5ef;
    padding: 3px 10px 2px;
    border-radius: 4px;
    font-weight: bold;
    color: #5270e4;
    margin-top: 2.5em;
    margin-bottom: 2em;
    margin-left: 8em;
    cursor: pointer;
}
.welcome-container{
    display: inline-flex;
}
@media (max-width: 750px){
    .back-button{
        margin-left: 0em;
    }
    .welcome{
        display: none;
    }
    .avatar-nav{
        background-image: none !important;
        border-radius: 8px !important;
        padding: 1px 0px 4px 7px;
        height: 1.5em !important;
        width: 2.3em !important;
        margin-top: 5px;
    }
    .avatar-nav div{
        width: 30px;
        height: 2px;
        background-color: #808080;
        margin: 5px 0;
    }
    .navbar{
        padding: 0.5rem 0.3rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue